"use client";

import { Sparkles, Bot, ShieldCheck, Award } from "lucide-react";
import { useLanguage } from "@/components/marketing/LanguageContext";
import { getSection02Data } from "./data";

const primaryLogo = "/marketing/fare-logo-trimmed.svg";
const coursesHero = "/marketing/courses_hero.jpg";

const featureIconMap = {
  Bot: Bot,
  ShieldCheck: ShieldCheck,
  Award: Award,
  Sparkles: Sparkles,
};

export default function Section02Mobile() {
  const { language } = useLanguage();
  const data = getSection02Data(language);

  return (
    <section
      id="section-02-coming-soon-mobile"
      aria-label="FARE Coming Soon Section"
      className="w-full relative scroll-mt-14 overflow-hidden font-['Outfit'] fare-noise-overlay pt-3 pb-8 px-4 flex flex-col justify-center shrink-0"
      style={{
        background:
          "linear-gradient(165deg, #FFFFFF 0%, #F8FAFD 30%, #F0F4FF 60%, #E6EEFF 100%)",
      }}
    >
      <div className="w-full flex flex-col space-y-2.5 relative z-10">
        <div className="flex flex-col items-start">
          <h2 className="text-2xl font-black text-[#0B1D3A] tracking-tight leading-tight mb-1.5">
            {data.headline}
          </h2>

          <p className="text-xs font-normal text-[#475569] leading-relaxed">
            {data.subtitle}
          </p>
        </div>

        <div className="relative w-full rounded-2xl overflow-hidden shadow-xl border border-white/90 flex flex-col items-center justify-end p-4 pt-16 pb-4 min-h-[500px] ">
          <img
            src={coursesHero}
            alt="FARE Experts"
            className="absolute inset-0 w-full h-full object-cover object-[center_20%]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0B1D3A]/85 via-[#0B1D3A]/40 to-black/20" />

          <div className="absolute top-3 right-3 z-40 bg-white/95 backdrop-blur-md rounded-xl px-3 py-1.5 border border-white shadow-lg flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-[#C99A2E] to-[#E2C068] text-white flex items-center justify-center shrink-0 shadow-xs">
              <Sparkles size={13} strokeWidth={2.4} className="text-white" />
            </div>
            <div>
              <div className="text-[8px] font-extrabold tracking-[0.14em] uppercase text-[#64748B] leading-none mb-0.5">
                {data.comingSoonCard.floatingBadge.tag}
              </div>
              <div className="text-[11px] font-extrabold text-[#0B1D3A] leading-tight">
                {data.comingSoonCard.floatingBadge.title}
              </div>
            </div>
          </div>

          <div className="relative z-30 w-full max-w-[360px] mb-6 rounded-2xl border border-white/85 bg-white/95 backdrop-blur-xl p-5 text-center shadow-[0_16px_40px_rgba(11,29,58,0.25)]">
            <div className="w-full flex items-center justify-center mb-2">
              <img
                src={primaryLogo}
                alt="FARE Logo"
                className="w-[210px] max-w-[85%] h-auto object-contain filter drop-shadow-xs"
              />
            </div>
            <h3 className="text-xl font-black text-[#0B1D3A] tracking-tight mb-3">
              {data.comingSoonCard.title}
            </h3>

            <div className="pt-3 border-t border-slate-200/80 flex flex-col gap-2 text-left">
              {data.comingSoonCard.features.map((feat, idx) => {
                const IconComponent = featureIconMap[feat.iconName] || Bot;
                return (
                  <div
                    key={idx}
                    className="text-xs font-semibold text-[#0B1D3A] flex items-center gap-2.5 p-1 rounded-lg"
                  >
                    <div
                      className="w-6 h-6 rounded-md flex items-center justify-center shrink-0 text-white shadow-xs"
                      style={{ backgroundColor: feat.color }}
                    >
                      <IconComponent size={13} strokeWidth={2.4} className="text-white" />
                    </div>
                    <span className="truncate">{feat.title}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
